import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LayoutDesplegable } from "../../layouts"
import { FormCreateUpdateItem, ItemsProduccionAndEditar } from "../components";
import { CargandoMedio, ModalFormulario } from "../../components";
import { iconos } from "../../../data";
import { useListadoCArritoXOp, useOPXID } from "../../../hooks/cache";
import { useCarritoItemsStore, useGlobalValueStore, useModalStore } from "../../../stores";




export const EditarOAgregarOP = () => {


    const { id } = useParams();
    const navigate = useNavigate();
    const { modalFormToggle } = useModalStore();
    const { setActivarItem } = useCarritoItemsStore();
    const { cambioRolVenta } = useGlobalValueStore();

    const { data:op } = useOPXID(id);
    const { data, isLoading} = useListadoCArritoXOp(id);


    useEffect(() => {
        if( op ){ cambioRolVenta(op.view) }
    }, [op])
    
    
    const cerrarModal = () => {
        setActivarItem(null);
        modalFormToggle(false)
    }



    const menu = [ 
        { title: 'Agregar Item', action:() => modalFormToggle(true), icon: iconos['plus'] },
        { title: 'Pagina Anterior', action:() => navigate(-1), icon: iconos['back'] },
    ];



    return (

        <LayoutDesplegable titulo="Información de O.P." subtitulo={`Información op: ${op?.op}`} menu={menu}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información items de op..." />
            :    <ItemsProduccionAndEditar data={data} />
            }

            <ModalFormulario titulo="Editar items de op" valor={{}} onClose={ cerrarModal }>
                <FormCreateUpdateItem />
            </ModalFormulario>
        </LayoutDesplegable>

    )
}
